import { styled } from "styled-components";

import { redundantCssFromKebab } from "../../../styles/redundant-css";

export const Logo = styled.svg`
    ${redundantCssFromKebab("display", "block")}
    ${redundantCssFromKebab("height", "auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("width", "auto")}
`;

// For backward compatibility - deprecated, use Logo component instead
export const logoStyle = {};
